import '../styles/navbar.css'

function Navbar() {
    return(<>

    <header>
    <div class="logo">Brujo Leo</div>
    <nav>
      <ul>
        <li><a href="#inicio">Inicio</a></li>
        <li><a href="#sobre-mi">Sobre mí</a></li>
        <li><a href="#servicios">Servicios</a></li>
        <li><a href="#contacto">Contacto</a></li>
        <li><a href="#ubicacion">Ubicación</a></li>
      </ul>
    </nav>
  </header>

    </>);
}

export default Navbar;